/*
 * @Description: 组件中使用配置项动态字段-字体-颜色等公用方法
 * @Author: shenah
 * @Date: 2023-03-29 17:07:54
 * @LastEditors: shenah
 * @LastEditTime: 2023-11-10 15:40:10
 */
import dataView from "./dataView";
import prefixSuffixRuleSetting from "./prefixSuffixRuleSetting";
import { createOneExpendStyle } from "_dataview/output/config/dynamicFieldConfig";
export default {
  mixins: [dataView, prefixSuffixRuleSetting],
  data() {
    return {
      originConfigMapRelations: {},
    };
  },
  methods: {
    getDynamicItem(attach) {
      if (!attach) return;
      let styleObj = attach.style;
      if (styleObj) {
        let height = this.transPX(styleObj.height);
        let lineHeight = styleObj.lineHeight;
        let align = styleObj.align;
        let verticalAlign = styleObj.verticalAlign;
        let lineNum = styleObj.lineNum;
        let paddingTop = this.transPX(styleObj.paddingTop);
        let paddingRight = this.transPX(styleObj.paddingRight);
        let paddingBottom = this.transPX(styleObj.paddingBottom);
        let paddingLeft = this.transPX(styleObj.paddingLeft);
        let padding = `${paddingTop} ${paddingRight} ${paddingBottom} ${paddingLeft}`;
        let relativeTop = this.transPX(styleObj.relativeTop);
        let relativeRight = this.transPX(styleObj.relativeRight);
        let relativeBottom = this.transPX(styleObj.relativeBottom);
        let relativeLeft = this.transPX(styleObj.relativeLeft);
        let overStyle = {};
        if (lineNum > 1) {
          overStyle = {
            display: "-webkit-box",
            overflow: "hidden",
            " text-overflow": "ellipsis",
            "-webkit-line-clamp": lineNum,
            "-webkit-box-orient": "vertical",
            "white-space": "normal !important",
            "word-break": "break-all",
          };
        }
        return {
          height,
          lineHeight,
          "justify-content": align,
          "align-items": verticalAlign,
          padding,
          top: relativeTop,
          right: relativeRight,
          bottom: relativeBottom,
          left: relativeLeft,
          ...overStyle,
        };
      }
      return;
    },
    getAttachNameStyle(attach) {
      if (!attach) return;
      let styleObj = attach.style;
      if (styleObj) {
        const fontSize = this.transPX(styleObj.nameFontSize);
        const fontWeight = styleObj.nameBoldFlag ? "bold" : undefined;
        const color = styleObj.nameColor;
        const fontFamily = styleObj.nameFontFamily;
        let style = {
          "font-size": fontSize,
          "font-weight": fontWeight,
          color: color,
        };
        if (fontFamily) {
          style.fontFamily = fontFamily;
        }
        return style;
      }
      return {
        "font-size": this.transPX(attach.nameFontSize),
        color: attach.nameColor,
      };
    },
    getAttachUnitStyle(attach, row) {
      if (!attach) return;
      let styleObj = attach.style;
      if (styleObj) {
        const fontSize = this.transPX(styleObj.unitFontSize);
        const fontWeight = styleObj.unitBoldFlag ? "bold" : undefined;
        const fontFamily = styleObj.unitFontFamily;
        let color = styleObj.unitColor;
        if (styleObj.unitToRuleFlag) {
          let anyObj = _.cloneDeep(attach.valueColorObj);
          anyObj.defaultValue = color;
          color = this.handleRule({
            anyObj,
            type: "color",
            row,
            attach,
          }).value;
        }
        return {
          fontFamily,
          "font-size": fontSize,
          "font-weight": fontWeight,
          color,
        };
      }
    },
    handleEveryThing(data) {
      let nowData = JSON.parse(JSON.stringify(data));
      // 处理值前缀图标与图片的展示
      nowData.forEach((it) => {
        let valueObj = {};
        let nameObj = {};
        this.mapRelations.attachArr.forEach((attach) => {
          valueObj[attach.uuid] = this.handleRule({
            anyObj: attach.valueIconObj,
            row: it,
            attach,
            type: "icon",
          });
          nameObj[attach.uuid] = this.handleRule({
            anyObj: attach.nameIconObj,
            row: it,
            prefix: "name",
            attach,
            type: "icon",
          });
        });
        it.valueAnything = valueObj;
        it.nameAnything = nameObj;
      });
      return nowData;
    },
    showImgStyle(obj) {
      return {
        width: this.transPX(obj.imgWidth),
        height: this.transPX(obj.imgHeight),
      };
    },
    handleRule2(obj, row) {
      if (!obj) return;
      let { defaultValue = null, ruleList = [] } = obj;
      let value = defaultValue;
      for (let i = 0; i < ruleList.length; i++) {
        let ruleObj = ruleList[i];
        let flag = this.$eval(ruleObj.rule, row);
        if (flag) {
          value = ruleObj.value;
          break;
        }
      }
      return value;
    },
    handleRule({ anyObj, row, type, prefix = "value", attach }) {
      if (!anyObj) return {};
      let { defaultValue = null, ruleList = [] } = anyObj;
      let value = {
        showType: attach[`${prefix}ShowType`] || "icon",
        showPosition: attach[`${prefix}ShowPosition`] || "before",
      };
      if (type === "color") {
        value.value = defaultValue;
      } else {
        if (value.showType === "img") {
          let imgObj = attach[`${prefix}ImgObj`];
          // 图片
          value.value = imgObj.defaultValue;
          value.imgWidth = imgObj.imgWidth;
          value.imgHeight = imgObj.imgHeight;
        } else {
          value.value = attach[`${prefix}IconObj`].defaultValue;
        }
      }
      for (let i = 0; i < ruleList.length; i++) {
        let ruleObj = ruleList[i];
        let flag = this.$eval(ruleObj.rule, row);
        if (flag) {
          if (type === "color") {
            value = {
              ...ruleObj,
            };
          } else {
            if (ruleObj.showType === "img") {
              ruleObj = attach[`${prefix}ImgObj`]?.ruleList[i] || ruleObj;
            }
            value = {
              ...ruleObj,
            };
          }
          break;
        }
      }
      return value;
    },
    getAttachValueIcon(
      attach,
      row,
      obj = {
        iconField: "valueIconObj",
      }
    ) {
      if (!attach) return;
      let icon = this.handleRule({
        anyObj: attach[obj.iconField],
        type: "icon",
        row,
        attach,
      }).value;
      return `iconfont icon-${icon}`;
    },
    getAttachValueIcon2(
      attach,
      row,
      obj = {
        iconField: "valueIconObj",
      }
    ) {
      if (!attach) return;
      let icon = this.handleRule2(attach[obj.iconField], row);
      return `iconfont icon-${icon}`;
    },
    getAttachValueStyle2(
      attach,
      row,
      obj = {
        colorField: "valueColorObj",
        fontField: "valueFontSize",
      }
    ) {
      if (!attach) return;
      let style = {};
      let title = row[attach.title] || attach.title;
      if (!title) {
        style["margin-left"] = "0px";
      }
      let styleObj = attach.style;
      let color = this.handleRule2(attach[obj.colorField], row);
      if (styleObj) {
        const fontSize = this.transPX(styleObj.valueFontSize);
        const fontWeight = styleObj.valueBoldFlag ? "bold" : undefined;
        return {
          ...style,
          "font-size": fontSize,
          "font-weight": fontWeight,
          color,
        };
      }
      return {
        ...style,
        "font-size": this.transPX(attach[obj.fontField]),
        color,
      };
    },
    // 目前没有用(后面有需求再改进)
    isShowNameBox(row, attach) {
      // 判断是否有值没有值就不显示这个div
      let field = attach.title;
      // 前后缀
      let pSFlag = row.nameAnything[attach.uuid].value;
      if (field || pSFlag) {
        return true;
      }
      return false;
    },
    // 目前没有用(后面有需求再改进)
    isShowNumBox(row, attach) {
      // 判断是否有值没有值就不显示这个div
      let field = attach.field;
      // 前后缀
      let pSFlag = row.valueAnything[attach.uuid].value;
      if (field || pSFlag) {
        return true;
      }
      return false;
    },
    getAttachValueStyle(
      attach,
      row,
      obj = {
        colorField: "valueColorObj",
        fontField: "valueFontSize",
        isBoldField: "valueBoldFlag",
        fontFamilyField: "valueFontFamily",
      }
    ) {
      if (!attach) return;
      if (!attach[obj.colorField]) {
        return this.getAttachNameStyle(attach);
      }
      let style = {};
      let title = row[attach.title] || attach.title;
      if (!title) {
        style["margin-left"] = "0px";
      }
      let styleObj = attach.style;
      let color = this.handleRule({
        anyObj: attach[obj.colorField],
        type: "color",
        row,
        attach,
      }).value;
      if (styleObj) {
        const fontSize = this.transPX(styleObj[obj.fontField]);
        const fontWeight = styleObj[obj.isBoldField] ? "bold" : undefined;
        const fontFamily = styleObj[obj.fontFamilyField];
        let valueMarginTop = this.transPX(styleObj.valueMarginTop);
        let valueMarginRight = this.transPX(styleObj.valueMarginRight);
        let valueMarginBottom = this.transPX(styleObj.valueMarginBottom);
        let valueMarginLeft = this.transPX(styleObj.valueMarginLeft);
        let valueMargin = `${valueMarginTop} ${valueMarginRight} ${valueMarginBottom} ${valueMarginLeft}`;
        // 默认走规则,兼容之前没有这个值
        if (styleObj.valueToRuleFlag !== undefined) {
          if (!styleObj.valueToRuleFlag) {
            let defaultColor = attach[obj.colorField]?.defaultValue;
            color = defaultColor ? defaultColor : color;
          }
        }
        let nowStyle = {
          ...style,
          "font-size": fontSize,
          "font-weight": fontWeight,
          color,
          margin: valueMargin,
        };
        if (fontFamily) {
          nowStyle.fontFamily = fontFamily;
        }
        // 是否是柱体并且是值
        if (styleObj.isBar && obj.colorField === "valueColorObj") {
          nowStyle.flex = 1;
        }
        return nowStyle;
      }
      return {
        ...style,
        "font-size": this.transPX(attach[obj.fontField]),
        color,
      };
    },
    dataExcelAnalysis(res) {
      let data = dsf.dataview.utils.dataExcelCommonExcelToArrayObj(
        res,
        (fieldArray) => {
          this.$emit("update:excelMapFieldList", fieldArray);
        }
      );
      // 更新字段
      this.$dataAnalysis(data);
    },
    getDigitalWholeConfig(attach) {
      let style = attach.style;
      let fontSize = style.valueFontSize;
      let isFontBold = style.valueBoldFlag;
      let color = style.valueColor;
      if (style.digitalWholeConfig) {
        // 为了兼容之前的属性
        style.digitalWholeConfig.fontSize = fontSize;
        style.digitalWholeConfig.isFontBold = isFontBold;
        style.digitalWholeConfig.color = color;
        return style.digitalWholeConfig;
      }
      let digitalWholeConfig = createOneExpendStyle().digitalWholeConfig;
      return {
        ...digitalWholeConfig,
        fontSize: fontSize,
        isFontBold: isFontBold,
        color: color,
      };
    },
    getProgressWrapStyle(attach) {
      let style = attach.style;
      let barConfig = style.barConfig;
      let width = this.transPX(barConfig.width);
      let nowStyle = {};
      if (width === "100%") {
        nowStyle.flex = 1;
      } else {
        nowStyle.width = width;
      }
      return nowStyle;
    },
    getOuterBarStyle(attach) {
      let style = attach.style;
      let barConfig = style.barConfig;
      return {
        height: this.transPX(barConfig.height),
        borderRadius: this.transPX(barConfig.borderRadius),
        background: barConfig.basicBgColor,
      };
    },
    getInnerStyle(attach, row) {
      let style = attach.style;
      let percent = Math.abs(row[attach.field]) * 1;
      let barConfig = style.barConfig;
      let minBarPercent = barConfig.minPercent;
      let borderRadius = `${this.transPX(
        barConfig.borderRadius
      )} 0 0 ${this.transPX(barConfig.borderRadius)}`;
      if (minBarPercent > percent) {
        percent = minBarPercent;
      }
      if (percent >= 100) {
        percent = 100;
        borderRadius = this.transPX(barConfig.borderRadius);
      }
      let background = barConfig.bgColor;
      let barRuleObj = barConfig.bgColorRule;
      if (barRuleObj) {
        let barColorStyle = this.handlePrefixSuffixRule(barRuleObj, row, {});
        background = barColorStyle.color ? barColorStyle.color : background;
      }
      let gradientColors = barConfig.gradientColors;
      if (barConfig.isGradient) {
        background = `linear-gradient(90deg,${gradientColors[0]},${gradientColors[1]})`;
      }
      return {
        width: `${percent}%`,
        borderRadius,
        background,
      };
    },
    isShowBarValue(attach) {
      let style = attach.style;
      let barConfig = style.barConfig;
      return barConfig.showValue;
    },
  },
};
